import { pluralize } from '@fourthwall/utils/dist/string';
const fromOptions = new Array(61).fill(0).map((_, index) => ({
    value: index.toString(),
    key: index.toString(),
    label: index === 0 ? 'Sign up' : `${index} ${pluralize(index, 'month')}`,
}));
export const MONTHS_FROM_OPTIONS = fromOptions;
const toOptions = new Array(60).fill(0).map((_, index) => ({
    value: (index + 1).toString(),
    key: (index + 1).toString(),
    label: `${index + 1} ${pluralize(index + 1, 'month')}`,
}));
export const MONTHS_TO_OPTIONS = [
    ...toOptions,
    {
        value: '0',
        key: '0',
        label: 'Forever',
    },
];
